import React, { useState, useEffect } from "react";
import NavHeader from "../../Common/NavHeader";
import BreadCrumb from "../../Common/BreadCrumb";
import Paginator from "../../Common/Paginator";
import { getSalesReportV1 } from "../api";
import useAppStore from "../../../store/global";
import { Spinner } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import SalesTableV1 from "./SalesTableV1";
import {  ToastContainer } from "react-toastify";

export default function SalesHomeV1() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const restName = queryParams.get('restaurant_name');

  const [reports, setReports] = useState([]);
  const { loading, setLoading, pageSize, dateRange, reportType } = useAppStore();
  const [pageNum, setPageNum] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    getSalesReportV1(pageNum, pageSize, id, dateRange, reportType)
      .then((data) => {
        setReports(data.sales_report);
        setTotalPages(data.totalPages)
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
      });
  }, [pageNum, dateRange, reportType]);

  return (
    <>
      <NavHeader view="scrapper" />
      <ToastContainer />
      <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
        <BreadCrumb text={`Restaurants > ${restName} > Sales Reports`} setPageIndex={setPageNum} />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <>
            <SalesTableV1 reports={reports} 
             restName={restName}
            />
            <Paginator
              pageNum={pageNum}
              setPageNum={setPageNum}
              totalPages={totalPages}
            />
          </>
        )}
      </div>
    </>
  );
}
